module.exports = __webpack_public_path__ + "static/img/2_1_9.c0d0629b.jpg";